// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { VisibleTiles } from './VisibleTiles';

export class BaseMapInfo implements IBaseMapInfo {
    tileMatrixCount!: number;
    tileMatrixIndex!: number;
    tileMatrixTileCountX!: number;
    tileMatrixTileCountY!: number;
    visibleTiles!: VisibleTiles[];

    constructor(data?: IBaseMapInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileMatrixCount = _data["tileMatrixCount"];
            this.tileMatrixIndex = _data["tileMatrixIndex"];
            this.tileMatrixTileCountX = _data["tileMatrixTileCountX"];
            this.tileMatrixTileCountY = _data["tileMatrixTileCountY"];
            if (Array.isArray(_data["visibleTiles"])) {
                this.visibleTiles = [] as any;
                for (let item of _data["visibleTiles"])
                    this.visibleTiles!.push(VisibleTiles.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseMapInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMapInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileMatrixCount"] = this.tileMatrixCount;
        data["tileMatrixIndex"] = this.tileMatrixIndex;
        data["tileMatrixTileCountX"] = this.tileMatrixTileCountX;
        data["tileMatrixTileCountY"] = this.tileMatrixTileCountY;
        if (Array.isArray(this.visibleTiles)) {
            data["visibleTiles"] = [];
            for (let item of this.visibleTiles)
                data["visibleTiles"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IBaseMapInfo {
    tileMatrixCount: number;
    tileMatrixIndex: number;
    tileMatrixTileCountX: number;
    tileMatrixTileCountY: number;
    visibleTiles: VisibleTiles[];
}